import * as XLSX from "xlsx";
import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";

const TrainingKPI = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/agrimis");
  };

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [showDateFilter, setShowDateFilter] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };
  const [data, setData] = useState([]);
  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };
  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);
  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);
  const toDate = new Date().toISOString().slice(0, 10);
  const [selectedToDate, setSelectedToDate] = useState(toDate);
  const { sendRequest: getTrainingKPIData } = useHttp();

  const fillTrainingKPIData = (
    employeeId,
    // stateName,
    // farmerNo,
    getType = ""
  ) => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (getType != "") {
      urlfilter = urlfilter + `&getType=${getType}`;
    }

    var url = `/api/trainingKPIReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getTrainingKPIData(
      {
        url: url,
      },
      (data) => {
        if (getType == "Excel") {
        } else {
          setData(data);
        }
      }
    );
  };

  useEffect(() => {
    fillTrainingKPIData(0, 0, "");
  }, [getTrainingKPIData]);

  const handleExportExcel = () => {
    const filename = "TrainingKPI.xlsx";

    if (!data || data.length === 0) {
      console.error("No data available for export.");
      return;
    }

    const processedData = data.map((item) => {
      return {
        "Promoter Id": item.employeeCode || "",
        "Agri Promoter Name": item.employeeName || "",
        "Doc No": item.docNo || "",
        "State": item.state || "",
        "LGA": item.lga || "",
        "Village Name": item.villageName || "",
        "Demo Location": item.demoLocation || "",
        "Training Topic": item.topic || "",
        "Training Location": item.venue || "",
        "Training type": item.trainingType || "",
        "Number of Attendees": item.numberOfAttendees || 0,
        "Number of Trainings": 0,
        "Product Type":  item.productType || "",
        "Product Name": item.productSubType && item.productSubType.includes('Fertilizer') ? (item.productSubType || "") : (item.productName || ""),
        "Product SKU": item.productSubType && item.productSubType.includes('Fertilizer') ? (item.productSKU || "") : ( ""),
        "Number of Fertilizer sold (Bags)": item.totalQuantityPurchsed|| 0,
        "Unit Price (N)": item.unitPrice|| 0,
        "Total Amount (N)": item.totalAmount|| 0,
      };
    });

    if (processedData.length === 0) {
      console.error("Processed data is empty. Cannot export.");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(processedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Training KPI Report");

    XLSX.writeFile(wb, filename);
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = () => {
    getEmp(
      {
        url: `/api/employeeListForTargetAllocation/?useCase=Agri Promoter&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        console.log("emp", data);
        // var emplist = data;

        setEmployeeData(data.employeeList);
        setEmployeeAllData(data.employeeList);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  // const formattedData = data.map((item) => {
  //   const farmer = item.farmerDetails?.[0] || {};

  //   // Sum up fertilizer-related quantities, unit prices, and total amount
  //   const totalUnitPrice =
  //     item.fieldDetails?.reduce(
  //       (sum, fd) => sum + (fd.itemUnitPrice || 0),
  //       0
  //     ) || 0;
  //   const totalAmount =
  //     item.fieldDetails?.reduce((sum, fd) => sum + (fd.amount || 0), 0) || 0;
  //   const totalFertilizerSold =
  //     item.fieldDetails?.reduce((sum, fd) => sum + (fd.itemQuantity || 0), 0) ||
  //     0;

  //   return {
  //     employeeCode: item.employeeCode || "",
  //     employeeName: item.employeeName || "",
  //     docNo: item.docNo || "",
  //     state: item.state || farmer.farmerState || "",
  //     lga: item.lga || farmer.farmerLga || "",
  //     villageName: item.villageName || farmer.farmerVillage || "",
  //     trainingTopic: item.topic || "",
  //     trainingId: item.trainingAttendanceId || "",
  //     venue: item.venue || "",
  //     trainingType: item.trainingType || "",
  //     numberOfAttendees: item.farmerDetails?.length || 0,
  //     numberOfTrainings: 1,
  //     numberOfFertilizerSold: totalFertilizerSold,
  //     unitPrice: totalUnitPrice,
  //     amount: totalAmount,
  //   };
  // });

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">Training KPI Report</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Agri Promoter Name</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value !== "0") userid = e.target.value;
                      setData([]);
                      setEmployeeId(userid);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillTrainingKPIData(employeeId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning mx-2"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>S/N</th>
                          <th>Promoter Id</th>
                          <th>Agri Promoter Name</th>
                          {/* <th>Doc No</th> */}
                          <th>State</th>
                          <th>LGA</th>
                          <th>Village Name</th>
                          <th>Demo Location</th>
                          <th>Training Topic</th>
                          <th>Subject</th>
                          {/* <th>Training Id</th> */}
                          <th>Training Location</th>
                          <th>Training type</th>
                          <th>Number of Attendees</th>
                          <th>Number of Trainings</th>
                          <th>Product Type</th>
                          <th>Product Name</th>
                          <th>Product SKU</th>
        
                          <th>Number of Fertilizer sold (Bags)</th>
                          <th>Unit Price (N)</th>
                          <th>Total Amount (N)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((itm, i) => (
                          <tr key={i} className="tablerowview">
                            <td>{i + 1}</td>
                            <td>{itm.employeeCode}</td>
                            <td>{itm.employeeName}</td>
                            {/* <td>{itm.docNo}</td> */}
                            <td>{itm.state}</td>
                            <td>{itm.lga}</td>
                            <td>{itm.villageName}</td>
                            <td>{itm.demoLocation}</td>
                            <td>{itm.topic}</td>
                            <td>{itm.subject}</td>
                            {/* <td>{itm.trainingId}</td> */}
                            <td>{itm.venue}</td>
                            <td>{itm.trainingType}</td>
                            <td>{itm.numberOfAttendees}</td>
                            <td>{itm.numberOfTrainings}</td>
                            <td>{itm.productType}</td>
                            <td>{itm.productSubType && itm.productSubType.includes('Fertilizer') ? (itm.productSubType || "") : (itm.productName || "")}</td>
                            <td>{itm.productSubType && itm.productSubType.includes('Fertilizer') ? (itm.productSKU || "") : ( "")}</td>
        
                            <td>{itm.totalQuantityPurchsed}</td>
                            <td>{itm.unitPrice}</td>
                            <td>{itm.totalAmount}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default TrainingKPI;
